import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import HistorySection from 'Components/HistorySection';
import type { IHistoryContext } from 'Containers/FormContextHandler';
import { withHistoryContext } from 'Containers/FormContextHandler';
import type { RelevantDocumentType } from '../definitions';
import { TreatmentHistorySection } from './components';
import { DocumentCreationButtonWithContext } from './components/DocumentCreationButtonWithContext';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<RelevantDocumentType>[] = [];
const PatientDoesNotWantRespiratorySupportTherapy = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  view,
}: IHistoryContext<IDocumentWithTypeV2<RelevantDocumentType>>): React.JSX.Element => (
  <HistorySection
    headerText={<FormattedMessage id="treatment.patientDoesNotWantRespiratorySupportTherapy.title" />}
    newButton={
      <DocumentCreationButtonWithContext
        name="patientDoesNotWantRespiratorySupportTherapy"
        text="treatment.patientDoesNotWantRespiratorySupportTherapy.newPatientDoesNotWantRespiratorySupportTherapy"
      />
    }
  >
    <TreatmentHistorySection
      documents={documents}
      startEdit={startEdit}
      type="patientDoesNotWantRespiratorySupportTherapy"
      view={view}
    />
  </HistorySection>
);

export default withHistoryContext(PatientDoesNotWantRespiratorySupportTherapy);
